import { RouteMap } from '@constants/routes';
import { NavigationNodeProps } from '@custom-types/NavbarTypes';

export const restrictedUsers = ['AMP'];

const navbarOptionMapingId = {
  monitoringOptions: 1,
  analysesOptions: 2,
  administrationOptions: 3,
};

// Monitoring Options
const unrestrictedMonitoringOptions = [
  {
    id: 11,
    label: 'navbar.menu.monitoring.import',
    path: RouteMap.UPLOAD_ROUTE,
    order: 1,
    limitedToRole: ['admin'],
  },
  {
    id: 12,
    label: 'navbar.menu.monitoring.measurementVisualization',
    path: RouteMap.MEASUREMENT_VISUALIZATION,
    order: 1,
    limitedToRole: ['admin'],
  },
  {
    id: 13,
    label: 'navbar.menu.monitoring.measurementExport',
    path: RouteMap.MEASUREMENT_EXPORT,
    order: 1,
    limitedToRole: ['admin'],
  },
  {
    id: 14,
    label: 'navbar.menu.monitoring.importedMeasurementsOverview',
    path: RouteMap.IMPORTED_MEASUREMENTS_OVERVIEW,
    order: 1,
    limitedToRole: ['admin'],
  },
];

const restrictedMonitorOptions: never[] = [];

const unrestrictedAnalysesOptions = [
  {
    id: 22,
    label: 'navbar.menu.analyses.pqIndex',
    path: RouteMap.PQ_INDEX,
    order: 1,
    limitedToRole: ['admin'],
  },
  {
    id: 23,
    label: 'navbar.menu.analyses.harmonicBackgroundLevel',
    path: RouteMap.HARMONIC_BACKGROUND_LEVEL,
    order: 1,
    limitedToRole: ['admin'],
  },
];

const restrictedAnalysesOptions = [
  {
    id: 24,
    label: 'navbar.menu.analyses.correlation',
    path: RouteMap.CORRELATION,
    order: 1,
    limitedToRole: ['admin'],
  },
  {
    id: 25,
    label: 'navbar.menu.analyses.trendIdentification',
    path: RouteMap.TREND,
    order: 1,
    limitedToRole: ['admin'],
  },
];

// Administration Options
const unrestrictedAdministrationOptions = [
  {
    id: 31,
    label: 'navbar.menu.administration.measuringPointManagement',
    path: RouteMap.ADMINISTRATION_ROUTE,
    order: 1,
    limitedToRole: ['admin'],
  },
  {
    id: 32,
    label: 'navbar.menu.administration.masterData',
    path: RouteMap.MASTERDATA_ADMINISTRATION_ROUTE,
    order: 2,
    limitedToRole: ['admin'],
  },
];

const restrictedAdministrationOptions: never[] = [];

const baseNavbarMenu = [
  {
    id: 1,
    label: 'navbar.menu.monitoring',
    order: 1,
    limitedToRole: ['admin'],
    options: [],
  },
  {
    id: 2,
    label: 'navbar.menu.analyses',
    order: 2,
    limitedToRole: ['admin'],
    options: [],
  },
  {
    id: 3,
    label: 'navbar.menu.administration',
    order: 3,
    limitedToRole: ['admin'],
    options: [],
  },
];

export const generateNavbarMenu = (tsoAbbreviation: string | undefined | null) => {
  if (tsoAbbreviation === undefined || tsoAbbreviation === null) return [];

  const isRestricted = restrictedUsers.includes(tsoAbbreviation);

  const monitoringOptions = [...unrestrictedMonitoringOptions, ...(isRestricted ? [] : restrictedMonitorOptions)];
  const analysesOptions = [...unrestrictedAnalysesOptions, ...(isRestricted ? [] : restrictedAnalysesOptions)];
  const administrationOptions = [
    ...unrestrictedAdministrationOptions,
    ...(isRestricted ? [] : restrictedAdministrationOptions),
  ];

  const options = {
    monitoringOptions,
    analysesOptions,
    administrationOptions,
  };
  const navbarMenu: NavigationNodeProps[] = baseNavbarMenu.map((menuItem) => {
    const matchKey = Object.keys(navbarOptionMapingId).find(
      (key) => navbarOptionMapingId[key as keyof typeof navbarOptionMapingId] === menuItem.id
    );

    if (matchKey) {
      return {
        ...menuItem,
        options: [...menuItem.options, ...options[matchKey as keyof typeof options]],
      };
    }
  });

  return navbarMenu;
};
